export const firstColor = "#104470";
export const secondColor = "#104470";
export const thirdColor = "#104470";
export const fourthColor = "#104470";
